import React, { useState, useEffect } from "react";
import './OrderSuccess.css'
import { useLocation , Link } from "react-router-dom";

const OrderSuccess = () => {
    const { state } = useLocation();
    const orderId = state?.orderId || "N/A";

    const [waNumber, setWaNumber] = useState('')

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/site-settings`)
            .then(res => res.json())
            .then(data => {
                if (data.success && data.settings.whatsappNumber) {
                    setWaNumber(data.settings.whatsappNumber)
                }
            })
            .catch(console.error)
    }, [])

    const waMessage = `Hi! My order ID is ${orderId}. Here is my payment slip.`;
    const waLink = waNumber ? `https://wa.me/${waNumber}?text=${encodeURIComponent(waMessage)}` : null;

    return (
        <div className="order-success">
            <div className="ordersuccess-card">
 
                {/* Success icon */}
                <div className="ordersuccess-icon-wrap">
                    <div className="ordersuccess-icon">✓</div>
                </div>
 
                <h1 className="ordersuccess-title">Order Placed!</h1>
                <p className="ordersuccess-subtitle">Thank you for your order. We've received it and it's pending payment confirmation.</p>
 
                {/* Order ID */}
                <div className="ordersuccess-order-id-block">
                    <p className="ordersuccess-order-id-label">Your Order ID</p>
                    <p className="ordersuccess-order-id">{orderId}</p>
                    <p className="ordersuccess-order-id-hint">Keep this ID — you'll need it when sending your payment slip.</p>
                </div>
 
                {/* Steps */}
                <div className="ordersuccess-steps">
                    <div className="ordersuccess-step">
                        <span className="ordersuccess-step-num">1</span>
                        <p>Make your bank transfer or payment</p>
                    </div>
                    <div className="ordersuccess-step-arrow">→</div>
                    <div className="ordersuccess-step">
                        <span className="ordersuccess-step-num">2</span>
                        <p>Send the payment slip + Order ID to our WhatsApp</p>
                    </div>
                    <div className="ordersuccess-step-arrow">→</div>
                    <div className="ordersuccess-step">
                        <span className="ordersuccess-step-num">3</span>
                        <p>We'll confirm and dispatch your order</p>
                    </div>
                </div>

                {/* Bank account details */}
                <div className="ordersuccess-bank-block">
                    <p className="ordersuccess-bank-title">Bank Transfer Details</p>
                    <div className="ordersuccess-bank-rows">
                        <div className="ordersuccess-bank-row">
                            <span className="ordersuccess-bank-label">Account Name</span>
                            <span className="ordersuccess-bank-value">Jenitas</span>
                        </div>
                        <div className="ordersuccess-bank-row">
                            <span className="ordersuccess-bank-label">Account Number</span>
                            <span className="ordersuccess-bank-value ordersuccess-bank-mono">100590002942</span>
                        </div>
                        <div className="ordersuccess-bank-row">
                            <span className="ordersuccess-bank-label">Bank</span>
                            <span className="ordersuccess-bank-value">Nation Trust Bank</span>
                        </div>
                        <div className="ordersuccess-bank-row">
                            <span className="ordersuccess-bank-label">Branch</span>
                            <span className="ordersuccess-bank-value">Bandarawela</span>
                        </div>
                    </div>
                    <p className="ordersuccess-bank-note">
                        ⚠ Please include your <strong>Order ID ({orderId})</strong> in the payment remark / reference field when making the transfer.
                    </p>
                </div>
 
                {/* WhatsApp button */}
                {waLink ? (
                    <a href={waLink} target="_blank" rel="noreferrer" className="ordersuccess-wa-link">
                        <button className="ordersuccess-wa-btn">
                            <svg className="ordersuccess-wa-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                            </svg>
                            Send Payment Slip on WhatsApp
                        </button>
                    </a>
                ) : (
                    <p className="ordersuccess-no-wa">WhatsApp contact not configured yet. Please contact the store directly.</p>
                )}
 
                <Link to="/" className="ordersuccess-continue-link">
                    Continue Shopping →
                </Link>
 
            </div>
        </div>
    );
};

export default OrderSuccess;